import '../assets/apple-touch-icon-57-devel.png';
import '../assets/apple-touch-icon-57-prod.png';
import '../assets/apple-touch-icon-76-devel.png';
import '../assets/apple-touch-icon-76-prod.png';
import '../assets/apple-touch-icon-120-devel.png';
import '../assets/apple-touch-icon-120-prod.png';
import '../assets/apple-touch-icon-152-devel.png';
import '../assets/apple-touch-icon-152-prod.png';
import '../assets/favicon-devel.ico';
import '../assets/favicon-prod.ico';
